export default "__VITE_PUBLIC_ASSET__d11bb705__"